import { Injectable } from '@angular/core';
import { Observable } from 'rxjs'
import { IResponse, ILoginResponse } from '@interfaces/index';
import { HttpService } from '@ui-components/services/';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  constructor(
    private http_service: HttpService
  ) { }

  login(email_address: string, password: string, okta_access_token: any = null): Observable<IResponse<ILoginResponse>>  {
    return this.http_service.post('auth/login', {
      email_address: email_address,
      password: password,
      okta_access_token: okta_access_token
    })
  }

  forgotPassword(email_address: string): Observable<IResponse<ILoginResponse>>  {
    return this.http_service.post('auth/forgot-password', {
      email_address: email_address
    })
  }

  resetPassword(password: string, token: string): Observable<IResponse<ILoginResponse>>  {
    return this.http_service.post('auth/reset-password', {
      password,
      token
    })
  }

  setOktaUserAccessToken(email_address: string, access_token: string, sso_type: string): Observable<IResponse<ILoginResponse>> {
    return this.http_service.post('auth/set-access-token', {
        email_address,
        access_token,
        sso_type
    })
  }

}